"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Template_1 = require("./Template");
var assert_1 = require("../tools/assert");
var i18n_1 = require("../i18n");
exports.Info = (0, react_1.memo)(function (_a) {
    var kcContext = _a.kcContext, props = __rest(_a, ["kcContext"]);
    var _b = (0, i18n_1.getMsg)(kcContext), msg = _b.msg, msgStr = _b.msgStr;
    (0, assert_1.assert)(kcContext.message !== undefined);
    var messageHeader = kcContext.messageHeader, message = kcContext.message, requiredActions = kcContext.requiredActions, skipLink = kcContext.skipLink, pageRedirectUri = kcContext.pageRedirectUri, actionUri = kcContext.actionUri, client = kcContext.client;
    return ((0, jsx_runtime_1.jsx)(Template_1.Template, __assign({}, __assign({ kcContext: kcContext }, props), { doFetchDefaultThemeResources: true, displayMessage: false, headerNode: messageHeader !== undefined ? (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: messageHeader }) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: message.summary }), formNode: (0, jsx_runtime_1.jsxs)("div", __assign({ id: "kc-info-message" }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: "instruction" }, { children: [message.summary, requiredActions !== undefined && ((0, jsx_runtime_1.jsx)("b", { children: requiredActions.map(function (requiredAction) { return msgStr("requiredAction.".concat(requiredAction)); }).join(",") }))] })), !skipLink && pageRedirectUri !== undefined ? ((0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: pageRedirectUri }, { children: msg("backToApplication") })) })) : actionUri !== undefined ? ((0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: actionUri }, { children: msg("proceedWithAction") })) })) : (client.baseUrl !== undefined && ((0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: client.baseUrl }, { children: msg("backToApplication") })) })))] })) })));
});
//# sourceMappingURL=Info.js.map